import React from 'react'

export function LegalDisclaimer({
  text = ''
}: {
  readonly text?: string
}) {
  return (
    <p
      className="m-0 text-xs font-light whitespace-pre-line leading-relaxed text-neutral-dark mt-3 text-center"
      data-component="LegalDisclaimer"
    >
      {text}
    </p>
  )
}
